export default "__VITE_ASSET__ebac865e__"